import { Stack } from "@mui/material";
import { IconLock } from "src/components/icons-mui/lock";
import { Button } from "src/components-mui/base/button/button";
import { Typography } from "src/components-mui/base/typography/typography";
import { InfoBox } from "src/components-mui/pages/detail/certificate-box/components/info-box";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";

const CLOSED_DESCRIPTION_TEST_ID = "closed-description";
const CLOSED_BUTTON_TEST_ID = "closed-button";

export const CertificateBoxClosed = () => {
    const { dict, selectedCertificate: certificate } = useCertificateBoxContext();

    return (
        <>
            <Stack
                sx={{
                    p: 2,
                    gap: 2,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <InfoBox icon={<IconLock sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography
                        data-test-id={CLOSED_DESCRIPTION_TEST_ID}
                        sx={{
                            fontSize: "sm",
                        }}
                    >
                        {dict.closedTitle} {dict.closedDescription}
                    </Typography>
                </InfoBox>

                <Button
                    component="a"
                    href={certificate.closingClosedButtonUrl}
                    sx={{ width: "100%" }}
                    variant="contained"
                    color="green"
                    data-test-id={CLOSED_BUTTON_TEST_ID}
                >
                    {dict.closingClosedButton}
                </Button>
            </Stack>
        </>
    );
};
